import type { FaireProductEntity } from "../../entity_types/product";

export const p_3zc02t2r3l: FaireProductEntity = {
  token: "p_3zc02t2r3l",
  type: "product",
  name: "Helium 60 Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/6cb1440590cc2757c0a84ea609a3e53d30175139a8ed9433f661b52cabad5149.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f73a19543e7e554a15c6a98ca9a4dc3a4b0d0db35e05446d12da1594262f6902.png",
    "https://cdn.faire.com/fastly/372273c8c76e4d609bd66e7ae17129709d824886cb5efc3bae1ba73b8459b738.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:28.710Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
